import { render, staticRenderFns } from "./SettingsSystemSettingsDocumentNumberTemplateNewView.vue?vue&type=template&id=5bbcc042&scoped=true&"
import script from "./SettingsSystemSettingsDocumentNumberTemplateNewView.vue?vue&type=script&lang=js&"
export * from "./SettingsSystemSettingsDocumentNumberTemplateNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcc042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbcc042')) {
      api.createRecord('5bbcc042', component.options)
    } else {
      api.reload('5bbcc042', component.options)
    }
    module.hot.accept("./SettingsSystemSettingsDocumentNumberTemplateNewView.vue?vue&type=template&id=5bbcc042&scoped=true&", function () {
      api.rerender('5bbcc042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/system-settings/document-number-template/SettingsSystemSettingsDocumentNumberTemplateNewView.vue"
export default component.exports